import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type MarkNotificationReadMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type MarkNotificationReadMutation = {
  markNotificationRead?: {
    errors: Array<string>
    notification?: { id: string; read: boolean; readAt?: string | null } | null
  } | null
}

export const MarkNotificationReadDocument = gql`
  mutation markNotificationRead($id: ID!) {
    markNotificationRead(id: $id) {
      notification {
        id
        read
        readAt
      }
      errors
    }
  }
`
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<
  MarkNotificationReadMutation,
  MarkNotificationReadMutationVariables
>

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReadMutation, { data, loading, error }] = useMarkNotificationReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationReadMutation,
    MarkNotificationReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>(
    MarkNotificationReadDocument,
    options
  )
}
export type MarkNotificationReadMutationHookResult = ReturnType<
  typeof useMarkNotificationReadMutation
>
export type MarkNotificationReadMutationResult = Apollo.MutationResult<MarkNotificationReadMutation>
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationReadMutation,
  MarkNotificationReadMutationVariables
>
